/**
 * mco-product-hero.js
 * Replaces Kingdom's product-page image carousel with a single autoplay-loop-no-controls
 * Vimeo hero on /products/* pages.
 *
 * Behavior:
 *   1. Template gate — only runs on template-product pages.
 *   2. Finds the FIRST Vimeo iframe inside .product-gallery-main, extracts the Vimeo ID
 *      (slide 0 in the Kingdom gallery is the product's video).
 *   3. Inserts a sibling .mco-product-hero wrapper before the gallery, hides the
 *      gallery via the .mco-product-hero-active class on body. Gallery markup stays
 *      in the DOM (display:none) so variant images, swatches, and SEO references
 *      keep working.
 *   4. The new iframe uses Kingdom's exact Vimeo background-mode param set (verified
 *      working on live: autoplay+byline=0+controls=1+loop+playsinline+title=0+
 *      background=1+muted+dnt). The `playsinline=1` flag is load-bearing for
 *      mobile and turned out to also be the unlock for desktop autoplay on this
 *      account's videos. background=1 hides the player UI entirely.
 *   5. iframe pointer-events:none + a bottom mask div covers any control strip
 *      Vimeo might still draw — belt+suspenders.
 *
 * Why not edit Kingdom's slider liquid: SYSTEM-STATE rule 8 — never fork Kingdom
 * core sections. This sits on top, fully reversible by removing the include block
 * in layout/theme.liquid.
 */
(function () {
  'use strict';

  if ((document.body.className || '').indexOf('template-product') < 0) return;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var ran = false;
  function init() {
    if (ran) return;
    ran = true;

    var gallery = document.querySelector('.product-gallery-main');
    if (!gallery) return;

    var iframes = gallery.querySelectorAll('iframe');
    var ifrSrc = '';
    for (var i = 0; i < iframes.length; i++) {
      var s = iframes[i].getAttribute('src') || '';
      if (/(?:vimeo\.com\/video\/|player\.vimeo\.com\/video\/)\d+/.test(s)) {
        ifrSrc = s;
        break;
      }
    }
    if (!ifrSrc) return; // no video on this product, leave gallery alone

    var match = ifrSrc.match(/(?:vimeo\.com\/video\/|player\.vimeo\.com\/video\/)(\d+)/);
    var vimeoId = match[1];

    var hero = document.createElement('div');
    hero.className = 'mco-product-hero';
    hero.setAttribute('data-vimeo-id', vimeoId);

    var ifr = document.createElement('iframe');
    // Kingdom's exact background-mode param set — verified rendering live.
    ifr.src = 'https://player.vimeo.com/video/' + vimeoId +
      '?autoplay=1&byline=0&controls=1&loop=1&playsinline=1&title=0&background=1&muted=1&dnt=1&autopause=0';
    ifr.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
    ifr.setAttribute('allowfullscreen', '');
    ifr.title = 'Product preview video';
    hero.appendChild(ifr);

    var maskTop = document.createElement('div');
    maskTop.className = 'mco-product-hero__mask-top';
    hero.appendChild(maskTop);

    var maskBottom = document.createElement('div');
    maskBottom.className = 'mco-product-hero__mask-bottom';
    hero.appendChild(maskBottom);

    gallery.parentNode.insertBefore(hero, gallery);
    document.body.classList.add('mco-product-hero-active');
  }
})();
